import React from 'react';
import { Box } from '@mui/material';
import { ShowButton, EditButton } from '@refinedev/mui';
import { actionsContainerStyles } from '@/features/researchers/styles';

interface UserActionsProps {
  recordItemId: string | number;
}

/**
 * Component for user action buttons (show, edit)
 */
export const UserActions: React.FC<UserActionsProps> = ({ recordItemId }) => {
  return (
    <Box sx={actionsContainerStyles}>
      <ShowButton hideText recordItemId={recordItemId} />
      <EditButton hideText recordItemId={recordItemId} />
    </Box>
  );
};
